module.exports = __webpack_public_path__ + "static/media/heatloadCalculation.e8052884.svg";